import { render, staticRenderFns } from "./SucOrdered.vue?vue&type=template&id=3d150c66&"
import script from "./SucOrdered.vue?vue&type=script&lang=js&"
export * from "./SucOrdered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports